import { useContext } from "react";
import { ImportSidePanelAction } from "../actions";

import { AccessPointProcessingStep } from "../models";
import { ProviderNetworkImportContext } from "../providerNetworksImportContext";
import ImportConfigService from "../services/importConfigService";
import { ImportSidePanelState, ImportSidePanelTab } from "../state";

interface UseImportSidePanelReturnType {
  closeSidePanel: () => Promise<void>;
  openSidePanelResults: (versionId: number, step: AccessPointProcessingStep, tab: ImportSidePanelTab) => Promise<void>;
  sidePanel: ImportSidePanelState;
}

export function useImportSidePanel(): UseImportSidePanelReturnType {
  const { sidePanel, sidePanelDispatch } = useContext(ProviderNetworkImportContext);
  const importService = new ImportConfigService();

  const openSidePanelResults = async (versionId: number, step: AccessPointProcessingStep, tab: ImportSidePanelTab) => {
    sidePanelDispatch({ step, tab, type: ImportSidePanelAction.GetStepDetail, versionId });
    const stepDetail = await importService.GetStepDetail(step, versionId, true);
    sidePanelDispatch({ stepDetail, type: ImportSidePanelAction.GetStepDetailSuccess });
  };

  const closeSidePanel = async () => {
    sidePanelDispatch({ type: ImportSidePanelAction.HideSidePanel });
  };

  return {
    closeSidePanel,
    openSidePanelResults,
    sidePanel,
  };
}
